export default {"src":"/_next/static/media/Adolescent Gynecological Issues.fcd9a192.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};